import React, { Component } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';
import Dashboard from '../../views/Dashboard/';
import Charts from '../../views/Charts/';
import Widgets from '../../views/Widgets/';

// Components
import Buttons from '../../views/Components/Buttons/';
import Cards from '../../views/Components/Cards/';
import Forms from '../../views/Components/Forms/';
import Modals from '../../views/Components/Modals/';
import SocialButtons from '../../views/Components/SocialButtons/';
import Switches from '../../views/Components/Switches/';
import Tables from '../../views/Components/Tables/';
import Tabs from '../../views/Components/Tabs/';

// Surveys
import SurveysNew from '../../views/Surveys/New/';
import SurveysList from '../../views/Surveys/List/';
import SurveysView from '../../views/Surveys/View/';

// Users
import UsersNew from '../../views/Users/New';
import UsersList from '../../views/Users/List/';
import UsersView from '../../views/Users/View/';

// Account
import Profile from '../../views/Account/Profile';

// My Surveys
import MySurveysList from '../../views/MySurveys/List/';
import MySurveysView from '../../views/MySurveys/View/';

// Employee
import EmployeeList from '../../views/Employee/EmployeeList/';
import EmployeeView from '../../views/Employee/EmployeeView/';
import EmployeeNew from '../../views/Employee/EmployeeNew/';

// Employee Group
import EmployeeGroupList from '../../views/Employee/EmployeeGroupList/';
import EmployeeGroupView from '../../views/Employee/EmployeeGroupView/';
import EmployeeGroupNew from '../../views/Employee/EmployeeGroupNew/';

// Pages
import Support from '../../views/Pages/Support'

// Sidebars
import MainSidebar from '../../views/MainSidebar/';
import AccountSidebar from '../../views/Account/Sidebar/';
import UsersSidebar from '../../views/Users/Sidebar/';
import SurveysSidebar from '../../views/Surveys/Sidebar/';
import MySurveysSidebar from '../../views/MySurveys/Sidebar/';
import EmployeesSidebar from '../../views/Employee/Sidebar/';


// Icons
import FontAwesome from '../../views/Icons/FontAwesome/';
import SimpleLineIcons from '../../views/Icons/SimpleLineIcons/';

// Helper
import {checkBackend, requireAuthorization, checkFrontend, checkDoSurveys} from '../../components/Authorization'

class Full extends Component {

  render() {
    return (
      <div className="app">
        <Header />
        <div className="app-body">
          <Switch>
            <Route path="/components/*" component={Sidebar}/>
            <Route path="/account/*" component={MainSidebar}/>
            <Route path="/dashboard" component={MainSidebar}/>
            <Route path="/support" component={requireAuthorization(checkFrontend, MainSidebar)}/>
            <Route path="/icons/*" component={Sidebar}/>
            <Route path="/widgets" component={Sidebar}/>
            <Route path="/charts" component={Sidebar}/>
            <Route path="/users" component={requireAuthorization(checkBackend, UsersSidebar)}/>
            <Route path="/surveys" component={requireAuthorization(checkBackend, SurveysSidebar)}/>
            <Route path="/employees" component={requireAuthorization(checkBackend, EmployeesSidebar)}/>
            <Route path="/employee-groups" component={requireAuthorization(checkBackend, EmployeesSidebar)}/>
            <Route path="/my-surveys" component={requireAuthorization(checkDoSurveys, MySurveysSidebar)}/>
            <Route path="/my-surveys/*" component={requireAuthorization(checkDoSurveys, MySurveysSidebar)}/>
          </Switch>
          <main className="main">
            <Breadcrumb />
            <Container fluid>
              <Switch>
                <Route path="/dashboard" name="Dashboard" component={Dashboard}/>
                <Route path="/account/profile" component={Profile}/>
                <Route path="/users/view/:id/:hotelid" name="Users" component={requireAuthorization(checkBackend, UsersView)}/>
                <Route path="/users/new" name="Users" component={requireAuthorization(checkBackend, UsersNew)}/>
                <Route path="/users/list" name="Users" component={requireAuthorization(checkBackend, UsersList)}/>
                <Route path="/users" name="Users" component={requireAuthorization(checkBackend, UsersList)}/>
                <Route path="/surveys/view/:id" name="Surveys" component={requireAuthorization(checkBackend, SurveysView)}/>
                <Route path="/surveys/new" name="Surveys" component={requireAuthorization(checkBackend, SurveysNew)}/>
                <Route path="/surveys/list" name="Surveys" component={requireAuthorization(checkBackend, SurveysList)}/>
                <Route path="/surveys" name="Surveys" component={requireAuthorization(checkBackend, SurveysList)}/>
                <Route path="/employees/list" name="Employees" component={requireAuthorization(checkBackend, EmployeeList)}/>
                <Route path="/employees/view/:id" name="Employees" component={requireAuthorization(checkBackend, EmployeeView)}/>
                <Route path="/employees/new" name="Employees" component={requireAuthorization(checkBackend, EmployeeNew)}/>
                <Route path="/employees" name="Employees" component={requireAuthorization(checkBackend, EmployeeList)}/>
                <Route path="/employee-groups/list" name="Employee Groups" component={requireAuthorization(checkBackend, EmployeeGroupList)}/>
                <Route path="/employee-groups/view/:id" name="Employee Groups" component={requireAuthorization(checkBackend, EmployeeGroupView)}/>
                <Route path="/employee-groups/new" name="Employee Groups" component={requireAuthorization(checkBackend, EmployeeGroupNew)}/>
                <Route path="/employee-groups" name="Employee Groups" component={requireAuthorization(checkBackend, EmployeeGroupList)}/>

                <Route path="/support" name="Support" component={requireAuthorization(checkFrontend, Support)}/>
                <Route path="/my-surveys/view/:id/:hotelid" name="View Survey" component={requireAuthorization(checkDoSurveys, MySurveysView)}/>
                <Route path="/my-surveys" name="My Surveys" component={requireAuthorization(checkDoSurveys, MySurveysList)}/>
                <Route path="/components/buttons" name="Buttons" component={Buttons}/>
                <Route path="/components/cards" name="Cards" component={Cards}/>
                <Route path="/components/forms" name="Forms" component={Forms}/>
                <Route path="/components/modals" name="Modals" component={Modals}/>
                <Route path="/components/social-buttons" name="Social Buttons" component={SocialButtons}/>
                <Route path="/components/switches" name="Swithces" component={Switches}/>
                <Route path="/components/tables" name="Tables" component={Tables}/>
                <Route path="/components/tabs" name="Tabs" component={Tabs}/>
                <Route path="/icons/font-awesome" name="Font Awesome" component={FontAwesome}/>
                <Route path="/icons/simple-line-icons" name="Simple Line Icons" component={SimpleLineIcons}/>
                <Route path="/widgets" name="Widgets" component={Widgets}/>
                <Route path="/charts" name="Charts" component={Charts}/>
                <Redirect from="/" to={checkDoSurveys(this.props.state) ? "/my-surveys" : "/account/profile"}/>
              </Switch>
            </Container>
          </main>
          <Aside />
        </div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(connect(state => ({ state }))(Full));



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js